module.exports = __webpack_public_path__ + "static/photo-rachid-fa860fdd2abb0b60a1405fcd9ec30c25.jpg";